import { getData } from '../../_helpers/getData';
import React, { useEffect, useState, Component } from "react";
import axios from "axios";
import jwt_decode from "jwt-decode";
import Navbar from "./../../components/Navbar";
import TopBar from "./../../components/topbar";
import Footer from "./../../layout/footer";
import constant from '../../_config/constant';



export default function addPropertytype(props) {
  const [usertypeid, setUserTypeid] = useState("");
  const [name, setName] = useState("");
  const [lastconversationmessage, setLastConversationMessage] = useState("");
  const [datak, setDatak] = useState([]);
  const [status, setStatus] = useState("");

  const handleUserTypeidChange = (e) => {
    console.clear();
    setUserTypeid(e.target.value.toString());
  };

  const handleStatusChange = (e) => {
    console.clear();
    setStatus(e.target.value.toString());
  };

  const decoded = getData();

  function onCreatePost(e) {
    const postData = {
      usertypeid,
      name,
      lastconversationmessage,
      status,
    };

    e.preventDefault();

    axios.post(`/api/messageboard`, postData).then((response) => {
      // props.onPostAdded();
      props.history.push("/messageboard");
    });
  }

  useEffect(() => {
    axios.get("/api/usertype/").then((todo) => setDatak(todo.data));
  }, []);

  return (
    <div>
      <TopBar user={decoded} title="List"/>

        <div className="deznav">
          <div className="deznav-scroll">
            <Navbar />
          </div>
        </div>

        <div className="content-body">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <div className="tab-content">
                  <div className="tab-pane active show" id="All">
                    <form onSubmit={onCreatePost} enctype="multipart/form-data">
                      <div className="form-group row kimargin">
                        <label
                          for="staticEmail"
                          className="col-sm-2 col-form-label"
                        >
                          User Type
                        </label>
                        <div className="col-sm-10">
                          <select
                            name="usertypeid"
                            className="form-select kiselect"
                            onChange={(e) => handleUserTypeidChange(e)}
                            aria-label="Default select example"
                            required
                          >
                            <option value="">User Type</option>
                            {/* {datak.map((property) => (
                              <option value={property._id}>
                                {property.name}
                              </option>
                            ))} */}
                          </select>
                        </div>
                      </div>
                      <div className="form-group row kimargin">
                        <label
                          for="staticEmail"
                          className="col-sm-2 col-form-label"
                        >
                          Name
                        </label>
                        <div className="col-sm-10">
                          <input
                            type="text"
                            name="name"
                            value={name}
                            onChange={(e) => setName(e.target.value.toString())}
                            className="form-control"
                            placeholder="Name"
                            required
                          />
                        </div>
                      </div>

                      <div className="form-group row kimargin">
                        <label
                          for="staticEmail"
                          className="col-sm-2 col-form-label"
                        >
                          Last Conversation Message
                        </label>
                        <div className="col-sm-10">
                          <input
                            type="text"
                            name="lastconversationmessage"
                            value={lastconversationmessage}
                            onChange={(e) =>
                              setLastConversationMessage(
                                e.target.value.toString()
                              )
                            }
                            className="form-control"
                            placeholder="Last Conversation Message"
                            required
                          />
                        </div>
                      </div>

                      <div className="form-group row kimargin">
                        <label
                          for="staticEmail"
                          className="col-sm-2 col-form-label"
                        >
                          Status
                        </label>
                        <div className="col-sm-10">
                          <select
                            name="status"
                            value={status}
                            className="form-select kiselect"
                            onChange={(e) => handleStatusChange(e)}
                            aria-label="Default select example"
                            required
                          >
                            <option value="">Status</option>
                            <option value="Active">Active</option>
                            <option value="In-Active">In-Active</option>
                          </select>
                        </div>
                      </div>

                      <div className="form-group row kimargin">
                        <label
                          for="inputPassword"
                          className="col-sm-2 col-form-label"
                        >
                          &nbsp;
                        </label>
                        <div className="col-sm-10">
                          <button type="submit" className="btn btn-primary">
                            Save
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
    </div>
  );
}
